/**
 * The two fields of an invite — email address and role — shared by the Invite member dialog in
 * Settings and the setup panel's "Invite a team member" step (ACT2-1108).
 */
import { Input } from '@/_shared/components/ui/input';
import { Label } from '@/_shared/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/_shared/components/ui/select';

import type { InviteRole } from '../hooks/useInviteMember';

interface InviteMemberFieldsProps {
  /** Prefix for the field ids, so two forms on one page do not share an id. */
  idPrefix: string;
  email: string;
  onEmailChange: (email: string) => void;
  role: InviteRole;
  onRoleChange: (role: InviteRole) => void;
  disabled?: boolean;
}

export function InviteMemberFields({
  idPrefix,
  email,
  onEmailChange,
  role,
  onRoleChange,
  disabled = false,
}: InviteMemberFieldsProps): React.ReactElement {
  return (
    <div className="grid gap-4">
      <div className="grid gap-2">
        <Label htmlFor={`${idPrefix}-email`}>Email address</Label>
        <Input
          id={`${idPrefix}-email`}
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          placeholder="colleague@company.com"
          disabled={disabled}
        />
      </div>
      <div className="grid gap-2">
        <Label htmlFor={`${idPrefix}-role`}>Role</Label>
        <Select value={role} onValueChange={(v) => onRoleChange(v as InviteRole)} disabled={disabled}>
          <SelectTrigger id={`${idPrefix}-role`} className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="member">Member</SelectItem>
            <SelectItem value="admin">Admin</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
